<template>
  <v-dialog v-model="dialog" persistent max-width="750px" max-height="965px">
    <v-card id="videoMeetingEditDialog">
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-header">
          <h3 class="popup-title">영상회의 수정</h3>
          <div class="header-btn" style="margin-right: 30px;">
          </div>
        </div>
          <img
            @click="deleteMeeting()"
            src="../../../src/images/button/delBtn.png"
            style="margin-right:30px; cursor: pointer;"
          />
        </div>
        <div class="dialog-body">
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">제목</div>
            </div>
            <div class="dialog-contents">
              <input
                type="text"
                placeholder="필수 입력"
                v-model="editedMeetingInfo.title"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">일시</div>
            </div>
            <div class="dialog-date-contents" style="position: relative">
              <label style="display: flex; align-items: center;">
                <input
                    type="checkbox"
                    class="form-control"
                    style="margin-right: 5px;"
                    name="a"
                    v-model="immediateMeeting"
                  />
                  즉시회의
              </label>
              <date-picker
                :disabled-date="notBeforeToday"
                :disabled="meetingTypeFixed || isTimeFixed"
                :key="editedMeetingInfo.selectStartTime"
                :value="editedMeetingInfo.selectStartTime"
                @change="changeDate"
                format="YYYY-MM-DD"
                value-type="format"
                :lang="lang"
                style="width: 140px; height: 45px; margin-left: 10px; margin-right: 15px; font-size: 13px;"
              ></date-picker>
              <select
                class="formbox-time-select"
                v-model="editedMeetingInfo.startTime"
                @change="changedstartTime"
                :disabled="isTimeFixed || editedMeetingInfo.isImmediately"
                style="margin-right: 5px;"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
              <span style="font-size: 12px; margin-right: 5px;">~</span>
              <select
                class="formbox-time-select"
                v-model="editedMeetingInfo.endTime"
                @change="changedendTime"
                :disabled="isTimeFixed || immediateMeeting"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row attendee-row">
            <div style="width: 48%; display: flex; align-items: center;">
              <div class="dialog-title">
                <div class="dot-btn">&nbsp;</div>
                <div class="pl-2">참석자</div>
              </div>
              <div>
                <input
                  type="text"
                  class="select-input cursor-pointer"
                  style="font-size: 15px; width: 180px;"
                  placeholder="선택 사항"
                  @click="openMeetingInvitaionDialog()"
                  :value="attendeesString"
                  readonly
                />
              </div>
            </div>
            <div style="width: 43%;">
              <div style="display: flex; justify-content: end;">
                <div
                  class="dialog-title"
                  style="margin-left: 10px; width: 180px;"
                >
                  <div class="dot-btn">&nbsp;</div>
                  <div class="pl-2">레이아웃</div>
                </div>
                
                <input
                  type="text"
                  style="margin-left: 10px;"
                  class="select-input cursor-pointer"
                  v-if="editedMeetingInfo.layout.isLayout === false"
                  @click="openMeetingLayoutDialog()"
                  placeholder="선택사항"
                  readonly
                />

                <img
                  v-if="editedMeetingInfo.layout.isLayout"
                  class="fix-layout-img"
                  :src="editedMeetingInfo.layout.selectedLayoutImage"
                  @click="openMeetingLayoutDialog()"
                />
              </div>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">회의실</div>
            </div>
            <div class="dialog-contents">
              
              <input
                type="text"
                style="font-size: 15px; width: 60%;"
                placeholder="회의실 추가"
                :disabled="editedMeetingInfo.conferenceRooms"
                @click="openMeetingConferenceDialog"
                :value="editedMeetingInfo.selectedConferenceRoomString"
                readonly
              />
              <button style="height: 45px;" @click="openConferenceRoomsList()">회의실 예약현황</button>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">부가기능</div>
            </div>
            <div
              class="dialog-public-contents"
              style="flex-direction: column; align-items: start"
            >
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <div>
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                       v-model="editedMeetingInfo.meetingLog"
                    :disabled="editedMeetingInfo.meetingLogEn || editedMeetingInfo.conferenceRoomActive || editedMeetingInfo.exMeeting"
                    />
                    <span style="margin-left: 5px;">스마트회의록</span>
                  </label>
                </div>

                <!-- 실시간 자막 -->
                <div style="margin-left:20px;">
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="editedMeetingInfo.meetingLogEn"
                      :disabled="editedMeetingInfo.meetingLog || editedMeetingInfo.conferenceRoomActive || editedMeetingInfo.exMeeting"
                    />
                    <span style="margin-left: 5px;">스마트회의록(영문)</span>
                  </label>
                </div>
                <div style="margin-left:20px;">
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="editedMeetingInfo.exMeeting"
                      :disabled="isDisabled"
                    />
                    <span style="margin-left: 5px;">스마트 단말기 전용</span>
                  </label>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  margin-top: 10px;
                "
              >
                <label class="custom-label">
                  <input
                    type="checkbox"
                    class="form-control"
                    name="a"
                    v-model="editedMeetingInfo.allPublicMeeting"
                  />
                  <span style="margin-left: 5px;">전체 공개회의</span>
                </label>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <label class="custom-label" style="margin-left: 15px;">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meetingPublicType"
                    />
                    <span style="margin-left: 5px;">비밀번호</span>
                  </label>
                  
                  <input
                    :style="{ display: isPrivate }"
                    type="password"
                    placeholder="비밀번호를 입력하세요"
                    class="select-input"
                    style="margin-left: 12px; width: 180px"
                    v-model="editedMeetingInfo.meetingPW"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style="height: 50px;"></div>
          <div class="dialog-footer">
            <!-- <button class="dialog-delete" @click="deleteMeeting()">삭제</button> -->
            <button class="noIconButton" @click="close">취소</button>
            <button class="btnPrimary" @click="editMeeting">수정</button>
          </div>
        </div>
      </div>
    </v-card>
    <!-- <meeting-type-dialog
      :dialog="meetingTypeDialog.dialog"
      :attendeesInfo="meetingTypeDialog.attendees"
      :close="closeMeetingTypeDialog"
    /> -->
    <meeting-conference-dialog
      :dialog="meetingConferenceDialog.dialog"
      :meetingInfo="editedMeetingInfo"
      :conferenceRooms="editedMeetingInfo.conferenceRooms"
      :closeDialog="closeMeetingConferenceDialog"
      @selectedConferenceRooms="selectedConferenceRooms"
    />

    <meeting-invitaion-dialog
      :dialog="meetingInvitaionDialog.dialog"
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeMeetingInvitaionDialog="closeMeetingInvitaionDialog"
    />

    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      @selectedFixSeatList="selectedFixSeatList"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="editedMeetingInfo.layout.fixSeatList"
      :selectLayoutCode="editedMeetingInfo.layout.selectedLayoutCode"
      :conferenceRoomActive="conferenceRoomActive"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />

  </v-dialog>
</template>
<script>
import Util from "@/util";

import MeetingCreate from "@/components/meeting/MeetingCreate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import MeetingConferenceDialog from "@/components/popup/MeetingConferenceDialog";
import moment from "moment";
import timezone from "moment-timezone";
import MeetingInvitaionDialog from "@/components/popup/MeetingInvitaionDialog";
import BookmarkMeetingDialog from "@/components/popup/BookmarkMeetingDialog";
import AddBookmarkMeetingDialog from "@/components/popup/AddBookmarkMeetingDialog";
import GuideLogDialog from "@/components/popup/GuideLogDialog";
import RecLogDialog from "@/components/popup/RecLogDialog";
import MeetingLayoutDialog from "@/components/popup/MeetingLayoutDialog";
import ConferenceAgreeDialog from "@/components/popup/ConferenceAgreeDialog";

export default {
  filters: {
    conferenceDayFilter: function(day) {
      if (day === null) {
        return moment().format("YYYY / MM / DD");
      } else {
        return moment(day).format("YYYY / MM / DD");
      }
    },
    conferenceTimeFilter: function(time) {
      return moment(time).format("HH시 mm분");
    },
    textLengthOverCut (txt, len, lastTxt) {
      if (len === "" || len === null) {
        len = 5;
      }
      if (lastTxt === "" || lastTxt === null) {
        lastTxt = "...";
      }
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    },
  },
  components: {
    MeetingCreate,
    MeetingConferenceDialog,
    MeetingInvitaionDialog,
    MeetingLayoutDialog,
    BookmarkMeetingDialog,
    AddBookmarkMeetingDialog,
    ConferenceAgreeDialog,
    GuideLogDialog,
    RecLogDialog,
    DatePicker,
  },
  props: [
    "dialog",
    "closeDialog",
    "meetingInfo",
    "isTimeFixed",
    "isRoomSelectable",
    "isAdminPage",
    "mode",
  ],
  data() {
    return {
      meetingPublicType: false,
      meetingTypeFixed: false,
      isDeleteConf: false,
      lang: {
        days: ["일", "월", "화", "수", "목", "금", "토"],
        months: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월",
        ],
        yearFormat: "YYYY년",
        monthFormat: "MM월",
        // the calendar title of month before year
        monthBeforeYear: false,
      },
      pickrFormat: "YYYY-MM-DD",
      allPublicMeeting: false,
      max: 4,
      minDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      isHelpActive: "none",

      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingBookmarkImage: "/static/seoul/img/bookmark_off.png",
      meetingBookmarkActive: false,
      meetingLogActive: false,
      meetingTypeDialog: {
        dialog: false,
        attendees: [],
      },
      meetingConferenceDialog: {
        dialog: false,
        conferenceRooms: [],
      },
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectLayoutCode: null,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
        notice: {
          email: true,
          kakao: false,
        },
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      bookmarkMeetingDialog: {
        dialog: false,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      guideLogDialog: {
        dialog: false,
      },
      recLogDialog: {
        dialog: false,
      },
      addBookmarkMeetingBtn: false,
      layoutFixSeatList: {
        selectedLayoutCode: null,
        selectedLayoutImage: null,
        fixSeatList: [],
      },
      isPrivate: "",
      meetingType: null,
      meetingTypeTxt: "일반",
      conferenceRoomActive: false,
      isActive: "none",
      isRoomActive: "none",
      isActiveStartTime: "none",
      isInputLayout: "",
      isLayout: "none",
      guideLog: null,
      recLog: null,
      exMeeting: false,
      meetingLog: null,
      agreeConference: null,
      meetingBanner: false,
      bannerPosition: "bannerTop",
      meetingBannerActive: "none",
      defaultMeeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        fixSeatList: [],
        meetingRoom: null,
        meetingRoomId: null,
        roomIds: [],
        password: null,
        notice: {
          email: true,
          kakao: true,
        },
      },
      editedMeetingInfo: {
      },
      isDisabled: false,
      meeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        roomIds: [],
        password: null,
        notice: {
          email: true,
          kakao: true,
        },
      },
      error: null,
      immediateMeeting: false,
      repeatSetting: false,
      meetingTimeList: [],
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      guideLogContents: null,
      recLogContents: null,
      meetingTypeText: "개설",
      disabledBackground: "#f3f3f3",
      disabledColor: "#b8b8b8",
      meetingTypeBtn: "open",
    };
  },
  computed: {
    nowHour () {
      let hh = moment().format("HH");
      let mm = moment().format("mm");

      let setHour = "";

      if (mm < 30) {
        setHour = moment().format("YYYY-MM-DDTHH:mm:ss");
      } else {
        setHour = moment()
          .add("1", "h")
          .format("YYYY-MM-DDTHH:00:00");
      }

      return setHour;
    },
    reserveHour () {
      let time = this.meeting.startTime;
      if (time !== null) {
        if (time !== "") {
          let hh = time.split("T")[1].split(":")[0];
          let mm = time
            .split("T")[1]
            .split(":")[1]
            .split(":")[0];

          let setHour = "";
          if (mm === 30) {
            hh = parseInt(hh, 10) + 1;
            setHour = moment().format("YYYY-MM-DDT" + hh + ":00:ss");
          } else {
            setHour = moment()
              .add("30", "m")
              .format("YYYY-MM-DDT" + hh + ":30:ss");
          }

          return setHour;
        }
      }
    },
    getMaxDateTime () {
      return null;
    },
  },
  watch: {
    meetingInfo: {
      immediate: true,
      handler (val) {        
        if (val) {
          this.initTimeData();
          const copy = JSON.parse(JSON.stringify(val));
          let selectStartTime = moment(val.startDtime).format('YYYY-MM-DD');
          let startTime = moment(val.startDtime).format('HH:mm');
          let endTime = moment(val.endDtime).format('HH:mm');

          // // 시간 설정
          this.editedMeetingInfo = {
            ...copy,
            selectedConferenceRoomString: null,
            selectStartTime: selectStartTime,
            startTime: startTime,
            endTime: endTime,
          };
          
          this.meetingPublicType = this.editedMeetingInfo.isPrivate;
          this.isPrivate = this.editedMeetingInfo.isPrivate === true ? '' : 'none';

          if (this.editedMeetingInfo.attendees.length !== 0) {
            
            if (this.editedMeetingInfo.attendees.length > 1) {
              this.attendeesString = `${this.editedMeetingInfo.attendees[0].name} 외 ${this.editedMeetingInfo.attendees.length - 1}명`;
            } else {
              this.attendeesString = this.editedMeetingInfo.attendees[0].name;
            }
          }
          if (val.conferenceRooms) {
            console.log(val.conferenceRooms)
            if (this.editedMeetingInfo.conferenceRooms.length > 0) {
              this.editedMeetingInfo.selectedConferenceRoomString = `${this.editedMeetingInfo.conferenceRooms[0].deviceName}`;
              this.isDisabled = true;
              if (this.editedMeetingInfo.conferenceRooms.length > 1) {
                this.editedMeetingInfo.selectedConferenceRoomString = `${this.editedMeetingInfo.conferenceRooms[0].deviceName} 외 ${this.editedMeetingInfo.conferenceRooms.length - 1}곳`;
              }
            }
          }
        }
      },
    },
    meetingPublicType() {
      if (this.meetingPublicType === true) {
        this.isPrivate = "";
        this.editedMeetingInfo.isPrivate = true;
      } else {
        this.isPrivate = "none";
        this.editedMeetingInfo.isPrivate = false;
      }
    },
    immediateMeeting: function(val) {
      /* 즉시회의 여기서 작업하시면 됩니다. */
      this.isTimeFixed = true;
      this.immediateChange(val);
      this.editedMeetingInfo.selectStartTime = moment().format("YYYY-MM-DD");
    },
  },
  
  methods: {
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    async openConferenceRoomsList () {
      this.myWindow = window.open("http://mga.ksd.or.kr:8080/?paramData=eyJwcmdtSWQiOiJNR0FHTTAwNzdQMDMifQ==", "_blank", "width=1400, height=800");
    },
    initMeeting () {
      this.editedMeetingInfo = JSON.parse(JSON.stringify(this.meetingInfo));

      if (this.editedMeetingInfo.isInterlock) {
        this.meetingTypeFixed = true;
      }

      $("input[class=mx-input]").attr("readonly", true);

      this.editedMeetingInfo.selectStartTime = moment(
        this.editedMeetingInfo.startDtime
      )
        .utc()
        .format("YYYY-MM-DD");
      this.initTimeData();

      let meetingType = this.editedMeetingInfo.interlockSystem;

      // 스마트회의 일반회의 => 포털에서 수정 클릭 시

      if (meetingType) {
        if (meetingType === "video" || meetingType === "portal") {
          this.disabledBackground = "white";
          this.disabledColor = "#555";
          this.meetingTypeFixed = false;
          this.isTimeFixed = false;
          this.isEdit = "edit";
          this.meetingTypeBtn = "noOpen";
        } else {
          this.meetingTypeFixed = true;
          this.isEdit = "edit";
          this.meetingTypeBtn = "open";
          if (meetingType === "cooperation") {
            this.meetingTypeTxt = "협업공간";
          } else if (meetingType === "planner") {
            this.meetingTypeTxt = "플래너";
          } else if (meetingType === "flow") {
            this.meetingTypeTxt = "플래너";
          } else if (meetingType === "report") {
            this.meetingTypeTxt = "보고/회의";
          } else if (meetingType === "portal") {
            this.meetingTypeFixed = false;
          } else if (meetingType === "conf") {
            this.meetingTypeTxt = "차량/회의실";
          }
        }
        this.meetingType = this.editedMeetingInfo.meetingType;
      } else {
        this.disabledBackground = "white";
        this.disabledColor = "#555";
        this.meetingTypeFixed = false;
        this.isTimeFixed = false;
        this.meetingTypeBtn = "noOpen";
        meetingType = "portal";
      }
      if (this.editedMeetingInfo.conferenceRoomActive === true) {
        this.conferenceRoomActive = this.editedMeetingInfo.conferenceRoomActive;
        this.isRoomActive = "";
        if (this.editedMeetingInfo.conferenceRooms.length > 1) {
          this.selectedConferenceRoomString =
            this.editedMeetingInfo.conferenceRooms[0].deviceName +
            "외 " +
            parseInt(this.editedMeetingInfo.conferenceRooms.length - 1) +
            "곳";
        } else {
          if (this.editedMeetingInfo.conferenceRooms.length !== 0) {
            this.selectedConferenceRoomString = this.editedMeetingInfo.conferenceRooms[0].deviceName;
          }
        }
        // this.conferenceAgreeDialog.dialog = true;
      } else {
        this.isRoomActive = "none";
        this.meetingConferenceDialog.conferenceRooms = [];
      }
    },

    initTimeData () {
      this.meetingTimeList = [];
      let meetingInterval = 10;
      let time = moment();
      let staDate = moment(time.format("YYYY-MM-DD"));
      let endDate = time
        .clone()
        .add(1, "day")
        .format("YYYY-MM-DD");

      while (staDate.format("YYYY-MM-DD") < endDate) {
        this.meetingTimeList.push(staDate.format("HH:mm"));
        staDate = staDate.add(meetingInterval, "minutes");
      }
      // 초기 시간 선택
      if (
        this.meetingInfo.selectStartTime !== null &&
        this.meetingInfo.selectEndTime
      ) {
        this.meeting.startTime = this.meetingInfo.selectStartTime;
        this.meeting.endTime = this.meetingInfo.selectEndTime;
        this.startTime = moment(this.meeting.startTime).format("HH:mm");
        this.endTime = moment(this.meeting.endTime).format("HH:mm");
      } else {
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        if (this.immediateMeeting) {
          this.editedMeetingInfo.startTime = this.$t(
            "page.meeting-reserve.immediate"
          );
        } else {
          this.editedMeetingInfo.startTime = moment(this.meetingInfo.startDtime)
            .utc()
            .format("HH:mm");
        }
        this.endTime = nearestFuture.add(30, "minutes").format("HH:mm");
      }

      this.meeting.startTime = moment
        .tz(this.startDate + " " + this.startTime, moment.tz.guess())
        .utc()
        .format();
      this.meeting.endTime = moment
        .tz(this.startDate + " " + this.endTime, moment.tz.guess())
        .utc()
        .format();
    },
    openMeetingTypeDialog () {
      /* 미팅 유형 선택 팝업 */
      this.meetingTypeDialog.dialog = true;
    },
    openMeetingConferenceDialog () {
      this.meetingConferenceDialog.dialog = true;
      this.meetingConferenceDialog.conferenceRooms = this.editedMeetingInfo.conferenceRooms;
    },
    closeMeetingConferenceDialog () {
      this.meetingConferenceDialog.dialog = false;
    },
    closeConferenceAgreeDialog () {
      this.conferenceAgreeDialog.dialog = false;
    },
    close () {
      this.$emit("editedMeeting");
    },
    showDatePicker () {
      if (!this.editedMeetingInfo.isImmediately) {
        if (this.isActive === "none") {
          this.isActive = "";
        } else {
          this.isActive = "none";
        }
      }
    },
    startDateChange () {
      this.isActive = "none";
      this.editedMeetingInfo.selectStartTime = this.editedMeetingInfo.startDate;
    },
    showStartTimePicker () {
      if (this.isActiveStartTime === "none") {
        this.isActiveStartTime = "";
      } else {
        this.isActiveStartTime = "none";
      }
    },
    changedstartTime () {
      console.log(`changedstartTime`);
    },
    changedendTime () {
      console.log(`changedendTime`);
    },
    async editMeeting () {
      if (this.editedMeetingInfo.startTime === "즉시회의") {
        this.editedMeetingInfo.startTime = moment(new Date()).format("HH:mm");
        this.editedMeetingInfo.status = "s";
      }
      this.editedMeetingInfo.startDtime = moment
        .tz(
          `${this.editedMeetingInfo.selectStartTime.replace(/\./g, '-')} ${
            this.editedMeetingInfo.startTime
          }`,
          'Asia/Seoul'
        )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      this.editedMeetingInfo.endDtime = moment
        .tz(
          `${this.editedMeetingInfo.selectStartTime.replace(/\./g, '-')} ${
            this.editedMeetingInfo.endTime
          }`,
          'Asia/Seoul'
        )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      if (
        this.editedMeetingInfo.startDtime >= this.editedMeetingInfo.endDtime &&
        !this.immediateMeeting
      ) {
        if (
          this.editedMeetingInfo.startDtime === this.editedMeetingInfo.endDtime
        ) {
          Util.snackBarOpen(
            "시작일시와 종료일시가 같을 수 없습니다. 정확한 정보를 입력해주세요",
            "error"
          );
          return;
        } else {
          Util.snackBarOpen(
            "시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요",
            "error"
          );
          this.error =
            "시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요";
          return;
        }
      }

      if (this.editedMeetingInfo.conferenceRoomActive === true) {
        if (this.editedMeetingInfo.conferenceRooms === null) {
          Util.snackBarOpen("영상회의실을 추가해주세요", "error");
          return;
        } else {
          if (this.editedMeetingInfo.conferenceRooms.length === 0) {
            Util.snackBarOpen("영상회의실을 추가해주세요", "error");
            return;
          }
        }
      }

      if (
        moment(new Date()).format('YYYY.MM.DD') === this.editedMeetingInfo.startDate &&
        moment(new Date()).format('HH:mm') >= this.editedMeetingInfo.startTime &&
        !this.meeting.immediateMeeting
      ) {
        Util.snackBarOpen(
          '지난 시간입니다. 현재 시간 이후로 예약이 가능합니다.',
          'error'
        );
        return;
      }


      if (this.editedMeetingInfo.isPrivate === true) {
        if (
          this.editedMeetingInfo.meetingPW === null ||
          this.editedMeetingInfo.meetingPW === ""
        ) {
          Util.snackBarOpen("비밀번호를 입력하시기 바랍니다.", "error");
          return;
        }
      } else {
        this.editedMeetingInfo.meetingPW = null;
      }
      let now = moment()
        .utc()
        .format();
      if (now >= this.editedMeetingInfo.endDtime && this.immediateMeeting) {
        Util.snackBarOpen("예약시간 오류", "error");
        return;
      }

      this.editedMeetingInfo.conferenceRoomActive = this.conferenceRoomActive;
      this.editedMeetingInfo.fixSeatList = this.layoutFixSeatList.fixSeatList;
      this.editedMeetingInfo.layoutCode = this.layoutFixSeatList.selectedLayoutCode;
      this.editedMeetingInfo.layoutImage = this.layoutFixSeatList.selectedLayoutImage;

      let layoutCode = "";
      let fixSeatList = "";
      let openOption = "";

      let saehaLayoutCode = "";
      if (this.editedMeetingInfo.layoutCode !== null) {
  
        switch (this.editedMeetingInfo.layoutCode) {
          case "lay1":
            saehaLayoutCode = "4";
            break;
          case "lay2":
            saehaLayoutCode = "6";
            break;
          case "lay3":
            saehaLayoutCode = "7";
            break;
          case "lay4":
            saehaLayoutCode = "8";
            break;
          case "lay5":
            saehaLayoutCode = "9";
            break;
          case "lay6":
            saehaLayoutCode = "10";
            break;
          case "lay7":
            saehaLayoutCode = "11";
            break;
          case "lay8":
            saehaLayoutCode = "13";
            break;
          case "lay9":
            saehaLayoutCode = "14";
            break;
          case "lay10":
            saehaLayoutCode = "15";
            break;
          case "lay11":
            saehaLayoutCode = "18";
            break;
          case "lay12":
            saehaLayoutCode = "19";
            break;
          case "lay13":
            saehaLayoutCode = "20";
            break;
          case "lay14":
            saehaLayoutCode = "22";
            break;
        }
        layoutCode = "12849=0," + saehaLayoutCode;

        if (
          this.layoutFixSeatList.fixSeatList &&
          this.layoutFixSeatList.fixSeatList.length > 0
        ) {
          fixSeatList += "12888=";

          let seats = this.layoutFixSeatList.fixSeatList
            .filter(fixSeat => fixSeat.seat !== null)
            .map(fixSeat => {
              return (
                "0," +
                (fixSeat.id - 1) +
                ",0," +
                fixSeat.seat.split("_")[0] +
                "," +
                fixSeat.seat.split("_")[1]
              );
            });
          console.log(seats);
          fixSeatList += seats.join("|");
          openOption = layoutCode + "&" + fixSeatList;
        } else {
          openOption = layoutCode;
        }
      }
      this.editedMeetingInfo.roomOption = openOption;

      this.$http
        .post("/api/v1/meetings/editMeeting", this.editedMeetingInfo)
        .then(response => {
          let ret = response.data[0];

          console.log(ret);
          Util.snackBarOpen("영상회의 수정 완료", "success");
          this.immediateMeeting = false;
          this.close();
        })
        .catch(error => {
          console.log(`error`, error);
          this.error = error.response.data.error;
        });
    },
    async deleteMeeting () {
      if (confirm("삭제하시겠습니까?")) {
        let params = {
          meetingKey: this.editedMeetingInfo.meetingKey,
          meetingType: this.editedMeetingInfo.meetingType,
          creator: this.editedMeetingInfo.creator,
          email: this.editedMeetingInfo.creator.email,
        };

        await this.$http
          .post("/api/v1/meetings/deleteKrxMeeting", params)
          .then(response => {
            if (response) {
              if (response.data.result === false) {
                alert(response.data.message);
              }
              this.close();
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    selectedConferenceRooms (selectedConferenceRooms) {
      let rooms = "";
      this.selectedConferenceRoomArr = [];
      if (selectedConferenceRooms.length !== 0) {
        this.editedMeetingInfo.conferenceRooms = selectedConferenceRooms;
        for (let i = 0; i < selectedConferenceRooms.length; i++) {
          this.meeting.roomIds.push(selectedConferenceRooms[i]._id);
          if (i === selectedConferenceRooms.length - 1) {
            rooms += selectedConferenceRooms[i].deviceName;
          } else {
            rooms += selectedConferenceRooms[i].deviceName + ", ";
          }
          this.selectedConferenceRoomArr.push(selectedConferenceRooms[i]);
        }
        if (this.selectedConferenceRoomArr.length > 1) {
          this.editedMeetingInfo.selectedConferenceRoomString =
            this.selectedConferenceRoomArr[0].deviceName +
            "외 " +
            parseInt(this.selectedConferenceRoomArr.length - 1) +
            "곳";
        } else {
          this.editedMeetingInfo.selectedConferenceRoomString = this.selectedConferenceRoomArr[0].deviceName;
        }
      } else {
        this.editedMeetingInfo.conferenceRooms = [];
        this.editedMeetingInfo.selectedConferenceRoomString = null;
        this.isDisabled = false;
      }
    },
    immediateChange (immediate) {
      this.isActive = "none";
      if (immediate) {
        // 시작 시간 => 즉시로 변경
        // 시작 날짜 => 오늘로 변경
        this.meetingTimeList.unshift(this.$t("page.meeting-reserve.immediate"));
        this.editedMeetingInfo.startTime = this.meetingTimeList[0];
        
        this.editedMeetingInfo.startDate = moment().format("YYYY-MM-DD");

        let meetingInterval = 10;
        let time = moment();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        this.endTime = nearestFuture.add(30, "minutes").format("HH:mm");
      } else {
        // 즉시회의 해제 시 > 현재시간 근처 10분 반올림 작업
        const now = moment();

        const rounded = moment(Math.round(now.minutes() / 10) * 10, 'mm').set({
          year: now.year(),
          month: now.month(),
          date: now.date(),
          hour: now.hour(),
        });

        if (rounded.isBefore(now)) {
          rounded.add(10, 'minutes');
        }
        this.editedMeetingInfo.startTime = rounded.format('HH:mm');
        
        // this.initTimeData();


        this.isTimeFixed = false;
      }
    },
    deleteConferenceRoom (index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingType () {
      if (this.meetingType === "general") {
        this.meetingType = "general";
        this.attendeesString = this.$t("page.meeting-reserve.attendee-list");
      } else {
        this.meetingType = "article";
        this.attendeesString = this.$t(
          "page.meeting-reserve.attendee-list-type2"
        );
      }
    },
    closeGuideLogDialog (contents) {
      if (contents) {
        this.guideLogContents = contents;
      } else {
        // 취소
        this.guideLogContents = contents;
        this.guideLog = false;
      }
      this.guideLogDialog.dialog = false;
    },
    closeRecLogDialog (contents) {
      if (contents) {
        this.recLogContents = contents;
      } else {
        // 취소
        this.recLogContents = contents;
        this.recLog = false;
      }
      this.recLogDialog.dialog = false;
    },
    openMeetingInvitaionDialog () {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.editedMeetingInfo.attendees;
    },
    getAttendeesString (attendees) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name}`;
          } else if (attendees[0].email) {
            this.attendeesString = `${attendees[0].email}`;
          } else {
            this.attendeesString = `${attendees[0].phone}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name} 외 ${attendees.length -
              1}명`;
          } else if (attendees[0].email) {
            this.attendeesString = `${
              attendees[0].email
            } 외 ${attendees.length - 1}명`;
          } else {
            this.attendeesString = `${
              attendees[0].phone
            } 외 ${attendees.length - 1}명`;
          }
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }
      }
    },
    getConferenceRoomString (conf) {
      console.log(conf)
      if (conf.length > 1) {
        this.editedMeetingInfo.selectedConferenceRoomString =
          conf[0].deviceName +
          '외 ' +
          parseInt(conf.length - 1) +
          '곳';
      } else {
        this.editedMeetingInfo.selectedConferenceRoomString =
          conf[0].deviceName;
      }
    },
    closeMeetingInvitaionDialog (attendees, exMeeting) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name}`;
          } else if (attendees[0].email) {
            this.attendeesString = `${attendees[0].email}`;
          } else {
            this.attendeesString = `${attendees[0].phone}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name} 외 ${attendees.length -
              1}명`;
          } else if (attendees[0].email) {
            this.attendeesString = `${
              attendees[0].email
            } 외 ${attendees.length - 1}명`;
          } else {
            this.attendeesString = `${
              attendees[0].phone
            } 외 ${attendees.length - 1}명`;
          }
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }

        this.meetingInvitaionDialog.dialog = false;
        this.editedMeetingInfo.attendees = attendees;
        this.meeting.exMeeting = exMeeting;
      } else {
        this.meetingInvitaionDialog.dialog = false;
        this.editedMeetingInfo.attendees = attendees;
        this.meeting.attendees = attendees;
      }
    },
    openMeetingLayoutDialog () {
      /* 레이아웃 설정 */
      this.meetingLayoutDialog.attendees = this.editedMeetingInfo.attendees;
      this.meetingLayoutDialog.fixSeatList = this.editedMeetingInfo.layout;

      if (
        this.conferenceRoomActive &&
        this.editedMeetingInfo.conferenceRooms.length >= 1
      ) {
        if (this.editedMeetingInfo.conferenceRooms[0] === undefined) {
          alert("영상회의실을 추가해주세요");
          return;
        }
        let concatData = this.editedMeetingInfo.conferenceRooms.map(c => {
          return {
            email: c._id,
            name: c.name ? c.name : c.deviceName,
          };
        });
        this.meetingLayoutDialog.attendees = [];

        this.meetingLayoutDialog.attendees = this.meetingLayoutDialog.attendees.concat(
          concatData
        );
      }
      this.meetingLayoutDialog.dialog = true;
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList(selectedLayoutCode, selectedLayoutImage, fixSeatList) {

      if (selectedLayoutCode) {
        this.editedMeetingInfo.layout.isLayout = true;
      }
      this.editedMeetingInfo.layout.selectedLayoutCode = selectedLayoutCode;
      this.editedMeetingInfo.layout.selectedLayoutImage = selectedLayoutImage;
      this.editedMeetingInfo.layout.fixSeatList = fixSeatList;

      if (this.editedMeetingInfo.layout.selectedLayoutCode === null) {
        this.isInputLayout = '';
        this.isLayout = 'none';
      }

      this.closeMeetingLayoutDialog();
    },
    selectMeetingBookmark () {
      if (this.meetingBookmarkActive === false) {
        this.meetingBookmarkActive = true;
        this.meetingBookmarkImage = "/static/seoul/img/bookmark_on.png";
      } else {
        this.meetingBookmarkActive = false;
        this.meetingBookmarkImage = "/static/seoul/img/bookmark_off.png";
      }
    },
    selectedBookmarkMeeting (meeting) {
      console.log(meeting);
      /* 회의 제목 */
      this.meeting.title = meeting.title;

      /* 공개 비공개 */
      if (meeting.meetingPW === null) {
        this.meetingPublicType = "public";
      } else {
        this.isPrivate = "";
        this.meetingPublicType = "private";
        this.meeting.password = meeting.meetingPW;
      }

      /* 영상회의실 */
      this.conferenceRoomActive = meeting.conferenceRoomActive;

      /* 참석자 */
      this.attendeesString = meeting.attendeesString;
      this.meeting.attendees = meeting.attendees;

      /* 레이아웃 */
      if (meeting.layoutCode === null || meeting.layoutCode === undefined) {
        this.isLayout = "none";
        this.isInputLayout = "";
      } else {
        this.isLayout = "";
        this.isInputLayout = "none";
        this.layoutFixSeatList.layoutCode = meeting.layoutCode;
        this.layoutFixSeatList.selectedLayoutImage = meeting.layoutImage;

        this.meetingLayoutDialog.attendees = meeting.attendees;
        this.layoutFixSeatList.fixSeatList = meeting.fixSeatList;
        this.layoutFixSeatList.selectedLayoutCode = meeting.layoutCode;
        this.meetingLayoutDialog.selectLayoutCode = meeting.layoutCode;
      }

      /* 회의록 */
      this.meetingLog = meeting.meetingLog;
      /* 여기서 작업 */
    },
    changeDate (date) {
      this.$set(this.editedMeetingInfo, 'selectStartTime', date);
    },
  },
};
</script>
<style scoped>
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

#startDate1 {
  max-width: 150px;
  margin-right : 15px;
}
.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size: 12px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer {
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 45px;
}

.fix-layout-img {
  position: relative;
  width: 70px;
  left: -80px;
  top: 3px;
  cursor:pointer;
}

#bookmarkMeeting{
  text-align: center;
  font-size: 11.5pt;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  float: right;
  background: #cbe9f8;
  color: #2f66aa;
  border-radius: 5px;
}

#bookmarkAddMeeting{
  width: 130px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.help-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow: auto;
  text-align: center;
}
.help-img{
  width: 100%;
  max-width: 720px;
  display: inline-block;
  position: relative;
  top: 7%;
}
.close-img{
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}
input::placeholder{
  color: #bfc3c5;
  padding-left: 5px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bfc3c5 !important;
    font-size: 1rem !important;
}

.dialog-container {
  width: 100%;
}

#cmsMeeting:after {
  top:21px;
}

#videoMeetingCreateDialog input{
  font-size: 15px !important;
  font-weight: 300 !important;
  color: #1f2e3d;
}

input::placeholder{
  color: #b9b9b9;
  padding-left: 5px;
  font-size: 15px !important;
  font-weight: 100 !important;
  font-family: "Noto Sans KR", sans-serif !important;
}
.styled-checkbox:checked + label:after {
  position: absolute;
  left: 5px;
}

.custom-label {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/EditMeetingDialog.vue